import { createFeature, createReducer, createSelector } from '@ngrx/store';

import { blueSageQueueReducers } from './bluesage-queue.reducer';
import { blueSageQueueInitialState } from './bluesage-queue.state';

export const blueSageQueueFeature = createFeature({
    name: 'blueSageQueue',
    reducer: createReducer(blueSageQueueInitialState, ...blueSageQueueReducers),

    extraSelectors: ({ selectPage, selectSelectedId }) => ({
        /**
         * The row the resolve form is open on.
         *
         * Derived rather than duplicated into state: the page is the one source
         * of what a payment is, and a copy would go stale the moment the list
         * reloads under an open form. The job lookup needs the amount from here
         * to answer whether the job can take it as a payment.
         */
        selectSelectedPayment: createSelector(
            selectPage,
            selectSelectedId,
            (page, selectedId) => page?.payments.find((p) => p.id === selectedId),
        ),
    }),
});
